var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40266 4.36735C8.75211 4.58973 8.85513 5.0533 8.63275 5.40275L6.34353 9.00009H17.6565L15.3673 5.40275C15.1449 5.0533 15.2479 4.58973 15.5973 4.36735C15.9468 4.14497 16.4104 4.24798 16.6327 4.59744L19.4344 9.00009H21C21.5523 9.00009 22 9.44781 22 10.0001V11.0001C22 11.5524 21.5523 12.0001 21 12.0001H20L18.8412 20.2774C18.7029 21.2652 17.8579 22.0001 16.8605 22.0001H7.1395C6.14207 22.0001 5.29711 21.2652 5.15882 20.2774L4 12.0001H3C2.44772 12.0001 2 11.5524 2 11.0001V10.0001C2 9.44781 2.44772 9.00009 3 9.00009H4.56556L7.36725 4.59744C7.58963 4.24798 8.0532 4.14497 8.40266 4.36735ZM12 13.2501C11.5858 13.2501 11.25 13.5859 11.25 14.0001V15.7501H9.5C9.08579 15.7501 8.75 16.0859 8.75 16.5001C8.75 16.9143 9.08579 17.2501 9.5 17.2501H11.25V19.0001C11.25 19.4143 11.5858 19.7501 12 19.7501C12.4142 19.7501 12.75 19.4143 12.75 19.0001V17.2501H14.5C14.9142 17.2501 15.25 16.9143 15.25 16.5001C15.25 16.0859 14.9142 15.7501 14.5 15.7501H12.75V14.0001C12.75 13.5859 12.4142 13.2501 12 13.2501Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBasket);
export default __webpack_public_path__ + "static/media/add-basket.33c7381b38f6aa56c38422525b7eccbf.svg";
export { ForwardRef as ReactComponent };